import React from 'react'
import { useDispatch } from 'react-redux'
import { Radio as RadioAntd } from 'antd'
import 'antd/dist/antd.css'

const Radio = ({ name, action, defaultChecked, data }) => {
    const dispatch = useDispatch()

    const onChange = (e) => {
        dispatch(action(String(e.target.value)))
    }

    return (
        <div className="search-filter__prop">
            <div>{name}</div>
            <RadioAntd.Group className="radio__wrapper" onChange={onChange} value={defaultChecked}>
                {data.map((radio) => (
                    <RadioAntd className="radio" key={radio.val} value={radio.val}>
                        {radio.name}
                    </RadioAntd>
                ))}
            </RadioAntd.Group>
        </div>
    )
}

export default Radio
